import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { EmptyState, ErrorState, LoadingState, PageHeader } from '../components/ui';
import { adminApi } from '../lib/api';
import { formatDate } from '../lib/utils';

type StudioWorkspaceItem = {
  id: string;
  name: string;
  slug: string | null;
  type: string;
  studio_plan: string | null;
  members_count: number;
  created_at: string;
};

export function StudioWorkspacesPage() {
  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ['studio', 'workspaces'],
    queryFn: () => adminApi.studioWorkspaces(),
  });

  const items = (data as { items?: StudioWorkspaceItem[] } | undefined)?.items ?? [];

  return (
    <div>
      <PageHeader
        title="Studio workspaces"
        description="Подписки и баланс Studio по workspace."
      />
      {isLoading ? <LoadingState label="Загрузка workspaces..." /> : null}
      {isError ? <ErrorState message="Не удалось загрузить workspaces." onRetry={() => refetch()} /> : null}
      {data && items.length === 0 ? <EmptyState message="Workspaces не найдены." /> : null}
      {items.length > 0 ? (
        <div className="ops-card overflow-hidden p-0">
          <table className="ops-table">
            <thead>
              <tr>
                <th>Workspace</th>
                <th>Studio тариф</th>
                <th>Участники</th>
                <th>Создан</th>
              </tr>
            </thead>
            <tbody>
              {items.map((workspace) => (
                <tr key={workspace.id}>
                  <td>
                    <div className="font-medium">{workspace.name}</div>
                    <div className="text-xs text-ops-muted">{workspace.id}</div>
                  </td>
                  <td>{workspace.studio_plan ?? 'нет'}</td>
                  <td>{workspace.members_count}</td>
                  <td>{formatDate(workspace.created_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : null}
      <p className="mt-4 text-sm text-ops-muted">
        Для смены Studio тарифа используйте{' '}
        <Link className="text-ops-accent" to="/studio/users">
          карточку пользователя
        </Link>{' '}
        или API `POST /admin/v2/studio/workspaces/:workspaceId/plan`.
      </p>
    </div>
  );
}
